<template>
  <div>
    <div class="container loginIn">
      <div class="login-overlay"></div>
      <div :class="2 == 1 ? 'left' : 2 == 2 ? 'left center' : 'left right'">
        <el-form :label-width="1 == 3 || 1 == 2 ? '30px': '0px'" class="login-form" label-position="left">
          <div class="title-container"><h3 class="title">AI配煤管理系统登录</h3></div>
          <el-form-item
              :class="'style'+1"
              :label="1 == 3 ? '用户名' : ''" :style='{"padding":"0","boxShadow":"0 0 6px rgba(0,0,0,0)","margin":"0 0 12px 0","borderColor":"rgba(0,0,0,0)","backgroundColor":"rgba(0,0,0,0)","borderRadius":"0","borderWidth":"0","width":"50%","borderStyle":"solid","height":"auto"}'>
            <span v-if="1 != 3" class="svg-container" style="
			color:rgba(0, 0, 0, 1);
			line-height:30px;
			font-size:14px;
			width:30px;
			padding:0;
			margin:0;
			radius:0;
			border-width:0;
			border-style:solid;
			border-color:rgba(0,0,0,0);
			background-color:rgba(0,0,0,0);
			box-shadow:0 0 6px rgba(0,0,0,0);
			}"><svg-icon icon-class="user"/></span>
            <el-input v-model="rulesForm.account" name="account" placeholder="请输入账号" type="text"></el-input>
          </el-form-item>
          <el-form-item
              :class="'style'+1"
              :label="1 == 3 ? '密码' : ''" :style='{"padding":"0","boxShadow":"0 0 6px rgba(0,0,0,0)","margin":"0 0 12px 0","borderColor":"rgba(0,0,0,0)","backgroundColor":"rgba(0,0,0,0)","borderRadius":"0","borderWidth":"0","width":"50%","borderStyle":"solid","height":"auto"}'>
            <span v-if="1 != 3" class="svg-container" style="color:rgba(0, 0, 0, 1);
			line-height:30px;
			font-size:14px;
			width:30px;
			padding:0;
			margin:0;
			radius:0;
			border-width:0;
			border-style:solid;
			border-color:rgba(0,0,0,0);
			background-color:rgba(0,0,0,0);
			box-shadow:0 0 6px rgba(0,0,0,0);"><svg-icon icon-class="password"/></span>
            <el-input v-model="rulesForm.password" name="password" placeholder="请输入密码" type="password"></el-input>
          </el-form-item>
          <el-form-item class="setting">
            <el-button class="loginInBt" type="primary" @click="login()">{{ '1' == '1' ? '登录' : 'login' }}</el-button>
          </el-form-item>
          <a style="cursor:pointer;color:rgba(255,255,255,0.9);width:200px;font-size:14px" @click="show = true">下载AI配煤手机安装包</a>
        </el-form>
      </div>
      <app-download :show="show" v-on:listenToChildEvent="closeDialog"></app-download>

    </div>
    <div class="record-info">
      <p>备案信息：
        <a @click="openNewUrl" style="color: rgba(255,255,255,0.9);cursor: pointer">蒙ICP备2024019492号-1</a>
      </p>
    </div>
  </div>
</template>
<script>

import menu from "@/utils/menu";
import base from "@/utils/base";
import appDownload from "./app-download";

export default {
  components: {appDownload},
  data() {
    return {
      show: false,
      url: base.get().url,
      rulesForm: {
        account: "",
        password: "",
        role: "",
        code: '',
      },
      menus: [],
      roleOptions: [],
      tableName: "",
      codes: [{
        num: 1,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      }, {
        num: 2,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      }, {
        num: 3,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      }, {
        num: 4,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      }],
    };
  },
  mounted() {
    let menus = menu.list();
    this.menus = menus;
    for (let i = 0; i < this.menus.length; i++) {
      if (this.menus[i].hasBackLogin == '是') {
        let menuItem = {};
        menuItem["key"] = this.menus[i].roleName;
        menuItem["value"] = this.menus[i].tableName;
        this.roleOptions.push(menuItem);
      }
    }
  },
  created() {
    this.getRandCode()

  },
  methods: {
    openNewUrl() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    },
    closeDialog() {
      this.show = false;
    },
    menuChange(role) {
    },
    register(tableName) {
      this.$storage.set("loginTable", tableName);
      this.$router.push({path: '/register'})
    },
    // 登陆
    login() {
      let code = ''
      for (let i in this.codes) {
        code += this.codes[i].num
      }
      if (!this.rulesForm.account) {
        this.$message.error("请输入账号");
        return;
      }
      if (!this.rulesForm.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.roleOptions.length > 1) {
        let menus = this.menus;
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].tableName == this.rulesForm.role) {
            this.tableName = menus[i].tableName;
            this.rulesForm.role = menus[i].roleName;
          }
        }
      } else {
        this.tableName = this.roleOptions[0].value;
        this.rulesForm.role = this.roleOptions[0].key;
      }
      this.$http({
        url: this.url + `${this.tableName}/login?account=${this.rulesForm.account}&password=${this.rulesForm.password}`,
        method: "post"
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.$storage.set("Token", data.token);
          this.$storage.set("menuList", data.menuList);
          this.$storage.set("userId", data.userId);
          this.$storage.set("companyId", data.companyId);
          this.$storage.set("orgType", data.orgType);
          if (data.role.indexOf("admin") != -1) {
            this.$storage.set("role", "管理员");
          } else if (data.role.indexOf("cityProxy") != -1) {
            this.$storage.set("role", "城市代理");
          } else if (data.role.indexOf("siteProxy") != -1) {
            this.$storage.set("role", "到场地代理");
          } else {
            this.$storage.set("role", "用户");
          }
          this.$storage.set("sessionTable", this.tableName);
          this.$storage.set("adminName", data.fullName);
          this.$router.replace({path: "/index/"});
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getRandCode(len = 4) {
      this.randomString(len)
    },
    randomString(len = 4) {
      let chars = [
        "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k",
        "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v",
        "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G",
        "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R",
        "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2",
        "2", "4", "5", "6", "7", "8", "9"
      ]
      let colors = ["0", "1", "2", "2", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"]
      let sizes = ['14', '15', '16', '17', '18']

      let output = [];
      for (let i = 0; i < len; i++) {
        // 随机验证码
        let key = Math.floor(Math.random() * chars.length)
        this.codes[i].num = chars[key]
        // 随机验证码颜色
        let code = '#'
        for (let j = 0; j < 6; j++) {
          let key = Math.floor(Math.random() * colors.length)
          code += colors[key]
        }
        this.codes[i].color = code
        // 随机验证码方向
        let rotate = Math.floor(Math.random() * 60)
        let plus = Math.floor(Math.random() * 2)
        if (plus == 1) rotate = '-' + rotate
        this.codes[i].rotate = 'rotate(' + rotate + 'deg)'
        // 随机验证码字体大小
        let size = Math.floor(Math.random() * sizes.length)
        this.codes[i].size = sizes[size] + 'px'
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.loginIn {
  min-height: 100vh;
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url('https://images.unsplash.com/photo-1513828583688-c52646db42da?w=1920&q=80');
  background-color: #3a6ea5;

  .login-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(58, 110, 165, 0.7) 0%, rgba(43, 87, 151, 0.75) 100%);
    z-index: 0;
  }


  .loginInBt {
    width: 200px;
    height: 50px;
    line-height: 50px;
    margin: 10px 0 20px 400px;
    padding: 0;
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 4px;
    border-radius: 8px;
    border-width: 0;
    border-style: solid;
    border-color: transparent;
    background-color: var(--publicSubColor);
    box-shadow: 0 4px 12px rgba(232, 118, 58, 0.4);
    transition: all 0.3s ease;

    &:hover {
      background-color: #c9602d;
      box-shadow: 0 6px 16px rgba(232, 118, 58, 0.5);
      transform: translateY(-1px);
    }
  }

  .register {
    width: 100px;
    height: 20px;
    line-height: 20px;
    margin: 20px 0 0 55px;
    padding: 0 10px;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(216, 226, 233, 1);
    background-color: var(--publicSubColor);
    box-shadow: 0 0 6px rgba(255, 0, 0, 0);
    cursor: pointer;
  }

  .reset {
    width: auto;
    height: 20px;
    line-height: 20px;
    margin: -11px 15px 0 0;
    padding: 0px 5px;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    border-radius: 5px;
    border-width: 1px;
    border-style: dashed;
    border-color: rgba(216, 225, 232, 1);
    background-color: rgba(255, 215, 0, 1);
    box-shadow: 0 0 6px rgba(255, 0, 0, 0);
  }


  .left {
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 650px;
    height: auto;
    margin: 0;
    padding: 0 15px 0 20px;
    border-radius: 16px;
    border-width: 0px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0);
    background-color: rgba(255, 255, 255, 0.97);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
    z-index: 1;

    .login-form {
      background-color: transparent;
      width: 100%;
      right: inherit;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      position: initial;
      justify-content: center;
      flex-direction: column;
    }

    .title-container {
      text-align: center;
      font-size: 24px;

      .title {
        width: 80%;
        line-height: auto;
        margin: 25px auto;
        padding: 0;
        color: var(--publicMainColor);
        font-size: 24px;
        font-weight: 700;
        border-radius: 0;
        border-width: 0;
        border-style: solid;
        border-color: rgba(0, 0, 0, .3);
        background-color: rgba(0, 0, 0, 0);
        box-shadow: 0 0 6px rgba(0, 0, 0, 0);
      }
    }

    .el-form-item {
      position: relative;

      & /deep/ .el-form-item__content {
        line-height: initial;
      }

      & /deep/ .el-radio__label {
        width: auto;
        height: 14px;
        line-height: 14px;
        margin: 0;
        padding: 0 0 0 10px;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        border-radius: 0;
        border-width: 0;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0);
        background-color: rgba(255, 255, 255, 0);
        box-shadow: 0 0 6px rgba(255, 0, 0, 0);
        text-align: left;
      }

      & /deep/ .el-radio.is-checked .el-radio__label {
        width: auto;
        height: 14px;
        line-height: 14px;
        margin: 0;
        padding: 0 0 0 10px;
        color: var(--publicSubColor);
        font-size: 14px;
        border-radius: 0;
        border-width: 0;
        border-style: solid;
        border-color: rgba(216, 225, 232, 0);
        background-color: rgba(255, 255, 255, 0);
        box-shadow: 0 0 6px rgba(255, 0, 0, 0);
        text-align: left;
      }

      & /deep/ .el-radio__inner {
        width: 15px;
        height: 14px;
        margin: 0;
        padding: 0;
        border-radius: 100%;
        border-width: 1px;
        border-style: solid;
        border-color: #dcdfe6;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0 0 6px rgba(255, 0, 0, 0);
      }

      & /deep/ .el-radio.is-checked .el-radio__inner {
        width: 14px;
        height: 14px;
        margin: 0;
        padding: 0;
        border-radius: 100%;
        border-width: 1px;
        border-style: solid;
        border-color: var(--publicSubColor);
        background-color: var(--publicSubColor);
        box-shadow: 0 0 6px rgba(255, 0, 0, 0);
      }

      .svg-container {
        padding: 6px 5px 6px 15px;
        color: var(--publicMainColor);
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        padding: 0;
        line-height: 40px;
        width: 30px;
        text-align: center;
      }

      .el-input {
        display: inline-block;
        width: 100%;

        & /deep/ input {
          background: transparent;
          border: 0px;
          -webkit-appearance: none;
          padding: 0 15px 0 30px;
          color: var(--publicSubColor);
          height: 40px;

          width: 80%;
          height: 30px;
          line-height: 30px;
          margin: 0 0 0 50px;
          padding: 0 30px;
          color: rgba(0, 0, 0, 1);
          font-size: 16px;
          border-radius: 8px;
          border-width: 1px;
          border-style: solid;
          border-color: #dcdfe6;
          background-color: rgba(255, 255, 255, 0);
          box-shadow: 0 0 6px rgba(255, 0, 0, 0);
          transition: border-color 0.25s;

          &:focus {
            border-color: var(--publicMainColor);
          }
        }
      }

    }


  }

  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .right {
    position: absolute;
    left: inherit;
    right: 0;
    top: 0;
  }

  .code {
    .el-form-item__content {
      position: relative;

      .getCodeBt {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        line-height: 40px;
        width: 100px;
        background-color: rgba(51, 51, 51, 0.4);
        color: #fff;
        text-align: center;
        border-radius: 0 4px 4px 0;
        height: 40px;
        overflow: hidden;
        padding: 0;
        margin: 0;
        width: 100px;
        height: 30px;
        line-height: 30px;
        border-radius: 0;
        border-width: 0;
        border-style: solid;
        border-color: rgba(64, 158, 255, 1);
        background-color: rgba(51, 51, 51, 0.4);
        box-shadow: 0 0 6px rgba(255, 0, 0, 0);

        span {
          padding: 0 5px;
          display: inline-block;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .el-input {
        & /deep/ input {
          padding: 0 130px 0 30px;
        }
      }
    }
  }

  .setting {
    & /deep/ .el-form-item__content {
      box-sizing: border-box;
      line-height: 32px;
      height: 32px;
      font-size: 14px;
      color: #999;
      margin: 0 !important;
      display: flex;

      .register {
        text-align: center;
      }

      .reset {
        float: right;
        width: 50%;
        text-align: right;
      }
    }
  }

  .style2 {
    padding-left: 30px;

    .svg-container {
      left: -30px !important;
    }

    .el-input {
      & /deep/ input {
        padding: 0 15px !important;
      }
    }
  }

  .code.style2, .code.style3 {
    .el-input {
      & /deep/ input {
        padding: 0 115px 0 15px;
      }
    }
  }

  .style3 {
    & /deep/ .el-form-item__label {
      padding-right: 6px;
      height: 30px;
      line-height: 30px;
    }

    .el-input {
      & /deep/ input {
        padding: 0 15px !important;
      }
    }
  }

  & /deep/ .el-form-item__label {
    width: 30px;
    height: 30px;
    line-height: 30px;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    border-radius: 0;
    border-width: 0;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0);
  }

  .role {
    & /deep/ .el-form-item__label {
      width: 60px !important;
      height: 38px;
      line-height: 38px;
      margin: 0 10px 0 5px;
      padding: 0;
      color: rgba(0, 0, 0, 1);
      font-size: 14px;
      border-radius: 0;
      border-width: 0;
      border-style: solid;
      border-color: rgba(64, 158, 255, 1);
      background-color: rgba(255, 255, 255, 0);
      box-shadow: 0 0 6px rgba(255, 0, 0, 0);
      text-align: left;
    }

    & /deep/ .el-radio {
      margin-right: 12px;
      color: var(--publicSubColor);
    }
  }

}
.record-info {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  position: relative;
  z-index: 1;
}
.record-info a {
  color: rgba(255, 255, 255, 0.9);
}
.record-info a:hover {
  color: #ffd591;
}
</style>
